import { render, staticRenderFns } from "./AppSectionCard.vue?vue&type=template&id=779fedc0&"
import script from "./AppSectionCard.vue?vue&type=script&lang=js&"
export * from "./AppSectionCard.vue?vue&type=script&lang=js&"
import style0 from "./AppSectionCard.vue?vue&type=style&index=0&id=779fedc0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports